import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AdobeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"adobe"}/>
}
